const centerTriggeredAnimation = document.querySelectorAll('.moveAnimationCenter');

centerTriggeredAnimation.forEach((cta) => {
  gsap.to(cta, {
    scrollTrigger: {
      trigger: cta,
      start: 'top 50%',
      end: 'bottom bottom',
      onEnter: () => cta.classList.add('in-viewport'),
    },
  });
});
